package com.vizio.pay.api

import com.vizio.redwolf.utils.ClientConfig
import com.vizio.redwolf.utils.DEFAULT_RETRY_CONFIG
import com.vizio.redwolf.utils.DEFAULT_TIMEOUT
import com.vizio.redwolf.utils.RetryConfig
import com.vizio.redwolf.utils.clientprovider.ClientConfigFactory
import com.vizio.redwolf.utils.clientprovider.WebApiUseCase
import kotlin.js.JsExport

@JsExport
@JsName("JsClientConfig")
data class JsClientConfig(val timeout: Int, val jsRetryConfig: JsRetryConfig? = null)

@JsExport
@JsName("JsRetryConfig")
data class JsRetryConfig(val initialDelay: Int, val exponentialBase: Int, val retryAttempts: Int)

internal fun JsRetryConfig?.toRetryConfig(): RetryConfig {
    return RetryConfig(
        initialDelay = this?.initialDelay?.toLong() ?: DEFAULT_RETRY_CONFIG.initialDelay,
        exponentialBase = this?.exponentialBase ?: DEFAULT_RETRY_CONFIG.exponentialBase,
        retryAttempts = this?.retryAttempts ?: DEFAULT_RETRY_CONFIG.retryAttempts
    )
}

internal fun JsClientConfig?.toClientConfig(useCase: WebApiUseCase): ClientConfig {
    val timeout = this?.timeout?.toLong() ?: DEFAULT_TIMEOUT
    val retryConfig = this?.jsRetryConfig.toRetryConfig()
    return ClientConfigFactory.getClientConfig(useCase, timeout, retryConfig)
}